export default __webpack_public_path__ + "static/media/IconDesc_CopperDust.256.23671e1c.png";